"use strict";

var _interopRequireWildcard = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.sort");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var echarts = _interopRequireWildcard(require("echarts"));
var _dataMarket = require("@/api/dataMarket/dataMarket");
var _dataPresentation = _interopRequireDefault(require("./components/dataPresentation.vue"));
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DataMarket',
  components: {
    dataPresentation: _dataPresentation.default
  },
  data: function data() {
    return {
      aggregateData: [],
      timeData: [],
      registeredCountData: [],
      incomeData: [],
      orderAmountData: [],
      orderCountData: [],
      orderTotalIncomeData: [],
      orderCountTotalData: [],
      orderAmountTotalData: []
    };
  },
  created: function created() {
    this.listHistory();
  },
  methods: {
    onEach: function onEach() {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('main'));
      // 绘制图表
      var option = {
        title: {
          text: '30日数据趋势图'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: ['当日新增会员数', '当日总订单数', '当日有效订单数', '当日总订单金额', '当日有效订单金额', '当日总订单佣金', '当日有效订单佣金'],
          selected: {
            // '当日有效订单金额': false, // 设置为 false 表示默认不选中
            // '当日总订单佣金': false
            '当日总订单金额': false,
            '当日有效订单金额': false
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          data: this.timeData,
          axisTick: {
            alignWithLabel: true,
            customValues: [0, 0.5, 1, 1.5, 2, 8, 9]
          },
          axisLine: {
            // 轴线
            show: true,
            color: '#268C8C'
          }
        }],
        yAxis: [{
          type: 'value',
          position: 'left',
          splitArea: {
            show: true
          },
          axisLine: {
            // 轴线
            show: true,
            color: '#268C8C'
          }
        }],
        series: [{
          name: '当日新增会员数',
          type: 'line',
          areaStyle: {},
          smooth: true,
          emphasis: {
            focus: 'series'
          },
          data: this.registeredCountData
        }, {
          name: '当日总订单数',
          type: 'line',
          areaStyle: {},
          smooth: true,
          emphasis: {
            focus: 'series'
          },
          data: this.orderCountTotalData
        }, {
          name: '当日有效订单数',
          type: 'line',
          areaStyle: {},
          smooth: true,
          emphasis: {
            focus: 'series'
          },
          data: this.orderCountData
        }, {
          name: '当日总订单金额',
          type: 'line',
          areaStyle: {},
          smooth: true,
          emphasis: {
            focus: 'series'
          },
          data: this.orderAmountTotalData
        }, {
          name: '当日有效订单金额',
          type: 'line',
          areaStyle: {},
          smooth: true,
          emphasis: {
            focus: 'series'
          },
          data: this.orderAmountData
        }, {
          name: '当日总订单佣金',
          type: 'line',
          areaStyle: {},
          smooth: true,
          emphasis: {
            focus: 'series'
          },
          data: this.orderTotalIncomeData
        }, {
          name: '当日有效订单佣金',
          type: 'line',
          areaStyle: {},
          smooth: true,
          emphasis: {
            focus: 'series'
          },
          data: this.incomeData
        }]
      };
      myChart.setOption(option);
    },
    listHistory: function () {
      var _listHistory2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, timeData, registeredCountData, incomeData, orderAmountData, orderCountData, orderTotalIncomeData, orderCountTotalData, orderAmountTotalData, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {};
              _context.n = 1;
              return (0, _dataMarket.listHistory)(params);
            case 1:
              res = _context.v;
              res.data.dataList.sort(function (a, b) {
                return new Date(b.statsDate) - new Date(a.statsDate);
              });
              if (res.code === 0) {
                this.aggregateData = res.data.dataList.reverse();
                timeData = [];
                registeredCountData = [];
                incomeData = [];
                orderAmountData = [];
                orderCountData = [];
                orderTotalIncomeData = [];
                orderCountTotalData = [];
                orderAmountTotalData = [];
                this.aggregateData.forEach(function (element) {
                  timeData.push(element.statsDate);
                  registeredCountData.push(element.memberStat.registeredCount);
                  incomeData.push(element.orderStat.income);
                  orderAmountData.push(element.orderStat.orderAmount);
                  orderCountData.push(element.orderStat.orderCount);
                  orderTotalIncomeData.push(element.orderStatTotal.income);
                  orderCountTotalData.push(element.orderStatTotal.orderCount);
                  orderAmountTotalData.push(element.orderStatTotal.orderAmount);
                });
                this.timeData = timeData;
                this.registeredCountData = registeredCountData;
                this.incomeData = incomeData;
                this.orderAmountData = orderAmountData;
                this.orderCountData = orderCountData;
                this.orderTotalIncomeData = orderTotalIncomeData;
                this.orderCountTotalData = orderCountTotalData;
                this.orderAmountTotalData = orderAmountTotalData;
                this.onEach();
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function listHistory() {
        return _listHistory2.apply(this, arguments);
      }
      return listHistory;
    }()
  }
};